module.exports = __webpack_public_path__ + "static/cover-cropped-37402e423da8f6bc79361080e9e9b3a1.gif";